module.exports = __webpack_public_path__ + "media/src/website/images/locations/oberaudorf/oberaudorf_02-cd4e041a4f301e874e332acb95466c0e.jpg";